import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  approveDashboardAccessRequest,
  DashboardAccessRequestDecisionResponse,
  rejectDashboardAccessRequest,
} from "../../../api/dashboardAccessRequestsApi";
import { DashboardAccessRequest } from "../../../pages/Admin/Requests/dashboardAccessRequestsMockData";
import { DASHBOARD_ACCESS_REQUESTS_QUERY_KEY } from "./useDashboardAccessRequests";

// Approve/reject are live (see dashboardAccessRequestsApi.ts) - removes the decided item from the
// cached pending list directly on success instead of invalidating/refetching, since a refetch
// would just bring the same still-pending-server-side request straight back. { status: "failure" }
// is a real, non-throwing response shape (not an HTTP error) - checked explicitly rather than
// trusting onSuccess alone, since a mutation only calls onError for a thrown/rejected request.
const wasSuccessful = (response: DashboardAccessRequestDecisionResponse) => response?.status === "success";

export const useApproveDashboardAccessRequest = () => {
  const queryClient = useQueryClient();
  return useMutation(({ id, decisionNote }: { id: number; decisionNote?: string }) => approveDashboardAccessRequest(id, decisionNote), {
    onSuccess: (result, { id }) => {
      if (!wasSuccessful(result)) return;
      queryClient.setQueryData<DashboardAccessRequest[]>(DASHBOARD_ACCESS_REQUESTS_QUERY_KEY, (current) =>
        (current ?? []).filter((request) => request.id !== id)
      );
    },
  });
};

export const useRejectDashboardAccessRequest = () => {
  const queryClient = useQueryClient();
  return useMutation(({ id, decisionNote }: { id: number; decisionNote?: string }) => rejectDashboardAccessRequest(id, decisionNote), {
    onSuccess: (result, { id }) => {
      if (!wasSuccessful(result)) return;
      queryClient.setQueryData<DashboardAccessRequest[]>(DASHBOARD_ACCESS_REQUESTS_QUERY_KEY, (current) =>
        (current ?? []).filter((request) => request.id !== id)
      );
    },
  });
};
